import "hammerjs";
import {enableProdMode} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";

import {AppModule} from "./app/app.module";

import {environment} from "./environments/environment";
import {LoggerInit, LoggerLevel} from "./app/Logger/Logger";


export function getBaseUrl() {
  var url = document.getElementsByTagName("base")[0].href;
  url = url.endsWith("/") ? url.substr(0, url.length - 1) : url;
  return url;
}

const providers = [{provide: "BASE_URL", useFactory: getBaseUrl, deps: []}];

if(environment.production) {
  enableProdMode();
  LoggerInit(LoggerLevel.ERROR);
} else {
  LoggerInit(LoggerLevel.DEBUG);
}


const bootstrap = () => {
  platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));
};
if(typeof window['cordova'] !== 'undefined') {
  document.addEventListener('deviceready', () => {
    bootstrap();

    // (<any>window).cordova.InAppBrowser.addEventListener("loadstart", (evt) => {
    //   console.log(">>>>>>>>>>>>>>>>>>>");
    //   console.log(evt);
    // });
    var oldOpen = (<any>window).cordova.InAppBrowser.open;
    (<any>window).cordova.InAppBrowser.open = (url: string, target?: string, options?: string) => {
      if(!url.includes("localhost")) {
        return oldOpen(url, "_system", options);
      }
      else return oldOpen(url, target, options);
    };
    (<any>window).handleOpenURL = (url) => {
      console.log(">>>>>>>>>>>>>>>>>>>");
      // do stuff, for example
      // document.getElementById("url").value = url;
      console.log(url);
    };
  }, false);
} else {
  bootstrap();
}

// platformBrowserDynamic(providers)
//   .bootstrapModule(AppModule)
//   .catch(err => console.log(err));

// if (environment.name == "CORDOVA") {

//   let onDeviceReady = () => {
//     console.log('on ready');
//     platformBrowserDynamic(providers).bootstrapModule(AppModule)
//   };
//   console.log('on cordova');
//   document.addEventListener('deviceready', onDeviceReady, false);
// } else {
//   console.log('no cordova');
//   platformBrowserDynamic(providers)
//     .bootstrapModule(AppModule)
//     .catch(err => console.log(err));
// }



